@if (environment !== 'prod') {
  <div class="env__lbl">
    @for (item of [].constructor(16); track item; let i = $index) {
      <span>{{ environment }}</span>
    }
  </div>
}
